import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Alert, Modal, ModalHeader, ModalBody, ModalFooter } from '@/components/ui-compat'
import { Button as CompatButton } from '@/components/ui-compat'
import { Button } from '@/components/ui/button'
import { FolderPlus } from 'lucide-react'
import Grid from '../../../components/grid'
import Loader from '../../../components/Loading'
import ProjectsTableSkeleton from './ProjectsTableSkeleton'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { Query, Mutation } from '../../../api'
import { useRouter, useUser } from '../../../hooks'
import { useTranslation } from 'react-i18next'

export default () => {
  const { t } = useTranslation()
  const user = useUser()
  const { data, loading, error } = useQuery(Query.ORGANIZATION)
  const [deleteProject, deleteProjectData] = useMutation(Mutation.DELETE_PROJECT)
  const { match, history } = useRouter()
  const [projectToDelete, setProjectToDelete] = useState(null)
  const {
    organization: { projects },
  } = data || { organization: { projects: [] } }

  const handleDelete = () => {
    if (!projectToDelete) return
    deleteProject({
      variables: { userId: user.id, projectId: projectToDelete.id },
      refetchQueries: [{ query: Query.ORGANIZATION }],
    })
    setProjectToDelete(null)
  }

  if (error) return <Alert>{error.message}</Alert>
  if (loading && !data) return <ProjectsTableSkeleton />

  return (
    <>
      <Grid
        actionBar={{
          actionButton: (
            <Button
              size="sm"
              onClick={() => history.push(`${match.url}/projects/new`)}
            >
              <FolderPlus className="h-4 w-4" />
              {t('Organization_projects_new_project_btn')}
            </Button>
          ),
        }}
        formatters={[
          {
            formatter: ({ value, row }) => (
              <Link className="text-foreground" to={`${match.url}/projects/${row.id}`}>
                {value}
              </Link>
            ),
            for: ['name'],
          },
        ]}
        rows={projects}
        rowActions={[
          {
            title: t('Organization_projects_delete_project_btn'),
            color: 'danger',
            action: (row) => setProjectToDelete(row),
          },
        ]}
        columns={[{ name: 'name', title: t('Organization_projects_name_label') }]}
      />
      {deleteProjectData.loading && <Loader />}

      <Modal isOpen={!!projectToDelete} toggle={() => setProjectToDelete(null)}>
        <ModalHeader toggle={() => setProjectToDelete(null)}>
          {t('Organization_projects_archive_confirm_title', 'Archive Project')}
        </ModalHeader>
        <ModalBody>
          {t(
            'Organization_projects_archive_confirm_message',
            'Are you sure you want to archive project "{{name}}"? The project will be hidden but can be restored later.',
            { name: projectToDelete?.name },
          )}
        </ModalBody>
        <ModalFooter>
          <CompatButton color="secondary" onClick={() => setProjectToDelete(null)}>
            {t('cancel', 'Cancel')}
          </CompatButton>
          <CompatButton color="danger" onClick={handleDelete}>
            {t('Organization_projects_archive_btn', 'Archive')}
          </CompatButton>
        </ModalFooter>
      </Modal>
    </>
  )
}
